
const NotFound = () => <div>404 - Page Not Found</div>;
export default NotFound;
